import { FC } from 'react'
import { A11y } from 'swiper'
import { SwiperSlide } from 'swiper/react'

import { ScreenSize } from 'styles/mq'
import { Navigation } from './navigation'
import { SliderProps, useSlider } from './useSlider'
import { Preview } from './preview'
import {
  OverlayText,
  OverlayTextInner,
  SlideImage,
  SliderContainer,
  StyledSwiper,
} from './styled'

export const Slider: FC<SliderProps> = ({
  slides,
  capitalizeDescription,
  overlayOnlyOnHover,
  ...slideProps
}) => {
  const { swiper, setSlideIndex, openImageUrl, setOpenImageUrl, slide } =
    useSlider(slides)

  return (
    <SliderContainer>
      <StyledSwiper
        loop
        centeredSlides
        slidesPerView="auto"
        spaceBetween={8}
        onTransitionStart={s => setSlideIndex(s.realIndex)}
        onInit={s => {
          swiper.current = s
        }}
        modules={[A11y]}
        breakpoints={{
          [ScreenSize.MD]: {
            spaceBetween: 20,
          },
        }}
      >
        {slides.map((s, i) => (
          <SwiperSlide key={i}>
            {'link' in s ? (
              <a href={s.link} target="_blank" rel="noreferrer">
                <SlideImage {...slideProps} src={s.src} />
                <OverlayText $onlyOnHover={overlayOnlyOnHover}>
                  <OverlayTextInner>
                    {s.overlayText?.split(' ').map((word, index) => (
                      <span key={index}>{word} </span>
                    ))}
                  </OverlayTextInner>
                </OverlayText>
              </a>
            ) : (
              <SlideImage
                {...slideProps}
                src={s.src}
                onClick={() => setOpenImageUrl(s.src)}
              />
            )}
          </SwiperSlide>
        ))}
      </StyledSwiper>

      <Navigation
        capitalizeDescription={capitalizeDescription}
        title={slide.title}
        description={slide.description}
        note={slide.note}
        swiper={swiper}
      />

      <Preview
        openImageUrl={openImageUrl}
        onClose={() => setOpenImageUrl('')}
      />
    </SliderContainer>
  )
}
